import { render, staticRenderFns } from "./onlineStudentWithdrawalForm.vue?vue&type=template&id=0eb22e14"
import script from "./onlineStudentWithdrawalForm.vue?vue&type=script&lang=js"
export * from "./onlineStudentWithdrawalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports